<list-view *ngIf="listeConditions" [liste]="listeConditions"></list-view>

<floating-button [listeActions]="listeActions"></floating-button>